import { render, staticRenderFns } from "./RulesOverview.vue?vue&type=template&id=5db52544"
import script from "./RulesOverview.vue?vue&type=script&lang=js"
export * from "./RulesOverview.vue?vue&type=script&lang=js"
import style0 from "./RulesOverview.vue?vue&type=style&index=0&id=5db52544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports